<div #componentContainer style="width: 100% !important;">
    <audio style="width: 100% !important;"
        [src]="url" 
        controls >
    </audio>
</div>